import {
  useContext,
  useEffect,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import dynamic from "next/dynamic";
import PropTypes from 'prop-types';

import VasContext from 'context/VasContext';

import Image from "components/atoms/image/image";
import SnackBar from "components/atoms/snackBar/SnackBar";

import AffordabilityContainer from "components/molecules/affordabilityContainer/AffordabilityContainer";
import UnaffordableAlertModal from "components/molecules/unaffordableAlertModal/UnaffordableAlertModal";
import UpgradeComponent from "components/molecules/upgradeModal/UpgradeModal";

import ApplicationTypeSelector from "components/organisms/dealSpecifications/ApplicationTypeSelector";
import DealDurationAndPrice from "components/organisms/dealSpecifications/DealDurationAndPrice";
import DealSpecificationControl from "components/organisms/dealSpecifications/DealSpecificationControl"
import {
  SummeryWizard,
  WizardSection,
} from 'components/organisms/summeryWizard';
import DealDetailsIndicators from "components/organisms/dealDetailsIndicators/dealDetailsIndicators";
import * as DealSpecsHelper from "components/organisms/dealSpecifications/DealSpecificationsHelper";
import AddedToCartPopup from 'components/organisms/dealSpecifications/AddedToCartPopup';
import * as TaggingHelper from "components/organisms/dealSpecifications/DealSpecificationsTaggingHelper";
import DealHighlights from "components/organisms/dealHighlights/DealHighlights";
import {
  connect,
  CustomContainer,
  Router,
  Row,
  useRouter,
} from "components/atoms/DependencyHelper";

import styles from "./DealDetailsBody.module.scss";

import { createCartItems } from "utils/dealDetails";
import {
  componentResize,
  deleteSessionStorage,
  getCookieValue,
  imagePrefix,
  updateSessionStorage,
  getSessionStorage,
} from "utils/helperServices";
import ajaxService from "utils/ajaxServices";
import {
  useCartBundleOptions,
  useDealSelectionSummary,
  useDealInCartStatus,
  useProductTaggingInfo,
} from "utils/hooks/dealDetails";

import { addBundleProductToGuestCart } from "Redux/actions/cartAction";
import {
  displayHideUpgradeModal,
  updateUpgradeRedirect,
  clearUpgradeJourney,
  checkIfdealQualifies,
  updateJourneyStatus,
  updateSelectedData,
  setDevicePrice,
  getRecommendedDeals,
  fetchCreditFilters,
  addDealToCart,
} from "Redux/actions/upgradeAction";

import {
  setSelectedApplicationType as DealActionSetSelectedApplicationType
} from "Redux/actions/dealDetailsAction";

import { SET_IS_LOADING as SET_IS_LOADING_ACTION } from "Redux/actionTypes";

import {
  link as AnalyticsLink,
  getUtagData as AnalyticsGetUtagData,
  setPageName as AnalyticsSetPageName,
  getPageName as AnalyticsGetPageName
} from "services/analyticsUtag";

import {
  errorCodes,
  handoverUpgradeeSession,
  upgradeStages,
} from "services/upgradeService";
import { getVASContractCoverContent } from "services/vasDataService";

import DealDetailSummary from './DealDetailSummary';

import config from "../../../config";
import { BACK_ORDER_DEAL_AVAILABILITY_STATUS } from "../../../config/constants";
import labels from "../../../config/labels";
import types from "../../../config/types";

import AddOns from "./AddOns";

const VASAddons = dynamic(import("../../molecules/VASAddons/VASAddons"), {
  ssr: false,
});

const DealDetailsBody = ({
  addBundleProductToGuestCart,
  addDeal,
  addDealToCart,
  backOderDealUnavailable,
  canReciveOTP,
  checkIfdealQualifies,
  checkIsDealAffordable,
  clearUpgradeJourney,
  creditFilters,
  dealCategoryId,
  dealDetails,
  displayHideUpgradeModal,
  eligibleUpgradeList,
  features,
  fetchCreditFilters,
  getRecommendedDeals,
  handleContract,
  isChildAllowed,
  isMiniApp,
  isDealDetailPage,
  isShowAffordDeal,
  isVasloaded,
  selectedApplicationType,
  setDevicePrice,
  setSelectedApplicationType,
  updateJourneyStatus,
  showUpgradeModal,
  unMaskedMsisdn,
  updateSelectedData,
  updateUpgradeRedirect,
  upgradeCheckDone,
  upgradeResponse,
  urlQuery,
  userLoggedIn,
  lowCompLaod,
}) => {
  const env = config.env;
  const legacyEnv = config.envConfigs[env].legacyEnv;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const isMobile = componentResize();

  const cartBundleOptions = useCartBundleOptions();
  const dealSelectionSummary = useDealSelectionSummary();
  const isDealInCart = useDealInCartStatus();
  const productTaggingInfo = useProductTaggingInfo();

  const { vasList } = useContext(VasContext);

  const [alertModalContent, setAlertModalContent] = useState(null);

  const [contractCoverDescription, setContractCoverDescription] = useState();
  const [contractCoverTitle, setContractCoverTitle] = useState();

  const [isBackOrderDealUnavailable, setIsBackOrderDealUnavailableIsOutStock] = useState(false);
  const [isShowVas, setIsShowVas] = useState(false);
  const [isVasRemoved, setIsVasRemoved] = useState();

  const [preOrderMessage, setPreOrderMessage] = useState("");

  const [renderModal, setRenderModal] = useState(false);
  const [showAddons, setShowAddons] = useState(false);
  const [showAffordModal, setShowAffordModal] = useState(false);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showPreOrderInfo, setShowPreOrderInfo] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showUpgradeConfirmModal, setShowUpgradeConfirmModal] = useState(false);

  const buyOptions = dealDetails?.options ? dealDetails?.options[0]?.value : null
  const router = useRouter();

  const addDealToCartEnabled = features.addLineEnabled || features.newLineEnabled;

  const newRedirectURL = (features?.shakaEnabled && features?.shakaEnabled !== undefined) ? 'checkout' : 'shopping';

  const ctaText = DealSpecsHelper.getCTAText({
    features, dealDetails, userLoggedIn, upgradeCheckDone, eligibleUpgradeList
  });

  const analyticsData = TaggingHelper.generateAnalyticsData(dealDetails)
  let parentPageName;

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: SET_IS_LOADING_ACTION,
    payload: isLoading
  });

  const addDealToCartHandler = async (buyOptionTypeId) => {
    setLoadingState(true);

    const cartId = getCookieValue("cart_id");
    
    const cartArr = createCartItems({
      dealDetails,
      buyOptionTypeId,
      vasList,
      cartBundleOptions,
    })


    const cartResult = await addBundleProductToGuestCart(cartId, cartArr);

    setLoadingState(false);

    if (
      cartResult
      && !cartResult.errors
      && (!cartResult?.data || cartResult?.data?.addBundleProductsToCart)
    ) {
      setRenderModal(true);
      setShowSnackBar(true);
    } else if (cartResult?.status === BACK_ORDER_DEAL_AVAILABILITY_STATUS) {
      setIsBackOrderDealUnavailableIsOutStock(true);
      backOderDealUnavailable();
    }
  };

  const checkIfDealIsAffordable = (creditValue) => {
    if (
      creditValue?.financeIndicator
      && (creditValue?.financeIndicator === "Y" || creditValue?.financeIndicator === "N")
      && (Number(dealDetails?.monthly_recurring) > Number(creditValue?.total_monthly_payment)
        || Number(dealDetails?.installment) > Number(creditValue?.deviceInstallment))
    ) {
      getAlertPopupContent();
      setShowAlertModal(true);
    } else {
      handleAddDealToCart();
    }
  };

  const clickHandlerPrimary = async (isUpgrade = false, fireAnalytics = true) => {
    if (fireAnalytics) {
      TaggingHelper.tagJourneyChangeUse(labels.upgrade.lbl_continue_upgrade)
    }

    if (showUpgradeConfirmModal) {
      setShowUpgradeConfirmModal(false);
    }

    if (creditFilters?.total_monthly_payment) {
      fetchRecommendedDeals(creditFilters, isUpgrade);
    } else {
      let creditFiltersData = await fetchCreditFilters(upgradeResponse?.msisdn);

      if (!creditFiltersData.fail) {
        fetchRecommendedDeals(creditFiltersData, isUpgrade);
      } else {
        displayHideUpgradeModal(true);
        updateJourneyStatus(
          errorCodes.service_down,
          upgradeStages.TECHNICAL_ERROR
        );
      }
    }
  };

  const clickHandlerSecondary = () => {
    TaggingHelper.tagJourneyChangeUse(labels.upgrade.lbl_apply_new_contract);
    setShowUpgradeConfirmModal(false);
    clearUpgradeJourney();
    handleAddDealToCart();
  };

  const closeOptions = () => {
    setRenderModal(false);
  };

  const closeUnaffordableAlertModal = () => {
    setAlertModalContent(null);
  };

  const fetchPreOrderContent = async () => {
    try {
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "preOrderDealDetail"
      );

      if (result?.sections[0]?.items) {
        setPreOrderMessage(
          result.sections[0].items[0].description.replace(/<[^>]+>/g, "")
        );
        setShowPreOrderInfo(true);
      }
    } catch (e) {
      console.error(e)
    }
  };

  const fetchRecommendedDeals = (creditValue, isUpgrade = false) => {
    getRecommendedDeals(
      upgradeResponse?.msisdn,
      "",
      "",
      "",
      creditValue?.total_monthly_payment,
      Number(creditValue?.deviceInstallment),
      creditValue?.financeIndicator,
      dealDetails?.sku,
      isUpgrade ? upgradeResponse?.simOnlyUpgradeFlg : ""
    ).then((result) => {
      // 200 or 204 check isUpgradeAffordable("Y" | "N")
      if (result.fail) {
        displayHideUpgradeModal(true);
        updateJourneyStatus(
          errorCodes.service_down,
          upgradeStages.TECHNICAL_ERROR
        );

        return;
      }

      if (result?.response?.data?.isUpgradeAffordable === "N") {
        setShowAffordModal(true);
      } else {
        handleAddDealToCart(isUpgrade);
      }
    });
  };

  const isVasAvailableWithCurrentDeal = (isAvailable) => {
    setIsShowVas(isAvailable);
    isVasloaded(isAvailable);

    if (isAvailable) {
      // fetch drupal content
      getVASContractCoverContent().then((result) => {
        if (result?.sections[0]) {
          const item = result?.sections[0];
          setContractCoverTitle(item?.title);
          setContractCoverDescription(item?.description);
        }
      });
    }
  };

  const itemRemovedFromAddOns = (val) => {
    setIsVasRemoved(val);
  };

  const getAlertPopupContent = async () => {
    try {
      setLoadingState(true);

      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "dealDetailsUnaffordabilityError"
      );

      setAlertModalContent(result[0]);
    } catch (e) {
      setLoadingState(false);
    } finally {
      setLoadingState(false);
    }
  };

  const generateURLParameterString = (dealSelectionSummary) => {
    if (dealSelectionSummary) {
      var urlParamsString = '';
      var deviceCount = 0;
      var accessoryCount = 0;

      dealSelectionSummary.forEach(item => {
        let prefix = "";
        if (item.deviceType === "primary" || item.deviceType === "secondary") {
          deviceCount++;
          prefix = `dev${deviceCount}`;
        } else if (item.deviceType === "inclusion") {
          accessoryCount++;
          prefix = `acc${accessoryCount}`;
        }

        Object.entries(item).forEach(([key, value]) => {
          urlParamsString += `&${prefix}${key}=${encodeURIComponent(value)}`;
        });  
      });

      return urlParamsString;
    }
  };

  const handleAddToCart = (label) => {
    updateSession(label);
    deleteSessionStorage(labels.Session_Keys.lbl_cart_summary);
    updateSessionStorage(labels.Session_Keys.lbl_cart_summary, dealSelectionSummary);

    if (ctaText !== labels.deal_details.lbl_add_deal_cart) {
      handleAddDealToCart();
      return;
    }

    if (
      upgradeCheckDone
      && upgradeResponse
      && (upgradeResponse?.eligibilityStatus || upgradeResponse?.upgradeEligible)
    ) {
      parentPageName = AnalyticsGetPageName();
      TaggingHelper.tagJourneyChange();

      setShowUpgradeConfirmModal(true);

      return;
    }

    if (!upgradeCheckDone && isShowAffordDeal && creditFilters?.total_monthly_payment) {
      checkIfDealIsAffordable(creditFilters);
      return;
    }

    handleAddDealToCart();

    return;
  };
  const handleAddDealToCart = (isUpgrade = false) => {

    if (selectedApplicationType?.title === buyOptions[0]?.title) {
      if (isUpgrade && features?.upgradeEnabled) {
        addDealToCartHandler(buyOptions[1]?.option_type_id);
      } else if (isUpgrade) {
        navigateTo(
          `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=${dealDetails?.id}&dealSheetNumber=${dealDetails?.sku}${isMiniApp ? "&miniApp=true" : ""}`,
          true
        );
      } else if (addDealToCartEnabled) {
        addDealToCartHandler(selectedApplicationType?.option_type_id);
      } else {
        navigateTo(
          `https://www${legacyEnv}.vodacom.co.za/cloud/${newRedirectURL}/order-summary?salesChannel=Contract&dealSheetNumber=${dealDetails?.sku}${isMiniApp ? "&miniApp=true" : ""}${generateURLParameterString(dealSelectionSummary)}`
        );
      }

      return;
    }

    if (selectedApplicationType?.title === buyOptions[1]?.title && features?.upgradeEnabled) {
      addDealToCartHandler(selectedApplicationType?.option_type_id);
      return;
    } else if (selectedApplicationType?.title === buyOptions[1]?.title) {
      navigateTo(
        `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=${dealDetails?.id}&dealSheetNumber=${dealDetails?.sku}${isMiniApp ? "&miniApp=true" : ""}`,
        true
      );

      return;
    }
  };

  const handleContinueShopping = () => {
    closeOptions();
    setLoadingState(true);
    TaggingHelper.tagContinueShopping();

    router.push(`${urlPrefix}/products`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  const handleFindOut = () => {
    displayHideUpgradeModal(!showUpgradeModal);
  };

  const handleModalDismiss = () => {
    TaggingHelper.tagJourneyChangeDismiss();

    setShowUpgradeConfirmModal(false);
    AnalyticsSetPageName(parentPageName);
  };

  const handleSelectedBuyOption = (selectedOption) => {
    setSelectedApplicationType(selectedOption);

    AnalyticsLink({
      ...AnalyticsGetUtagData(),
      page_tool_event: "use",
      page_tool_name: "shopping: deal details: plan type filter",
      filter_query: selectedOption?.title || '',
    });
  };

  const handleSnackBarClose = () => {
    setShowSnackBar(false);
  };

  const handleUpgrade = (val) => {
    updateSession(labels.lbl_do_an_upgrade_check);
    deleteSessionStorage(labels.Session_Keys.lbl_cart_summary);
    updateSessionStorage(labels.Session_Keys.lbl_cart_summary, dealSelectionSummary);

    if (val == labels.lbl_do_an_upgrade_check && !features?.upgradeChecksEnabled) {
      navigateTo(
        `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/upgrades-check?dealsheet=${dealDetails?.sku}`
      );
    } else if (val == labels.lbl_do_an_upgrade_check) {
      setDevicePrice({
        devicePrice: dealDetails.monthly_recurring,
        installment: dealDetails.installment || 0,
        sku: dealDetails?.sku,
        analyticsOptions: {
          sales_product_id: [dealDetails?.sku],
          sales_product_quantity: [1],
          sales_product_category: [dealDetails?.categories?.[0]?.name],
          sales_product_price: [`${dealDetails?.monthly_recurring}`],
          sales_order_discount: dealDetails?.save_monthly_recurring,
        },
      });

      const redirectLink = `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=${dealDetails?.id}&dealSheetNumber=${dealDetails?.sku}${isMiniApp ? "&miniApp=true" : ""}`;

      displayHideUpgradeModal(!showUpgradeModal);
      updateUpgradeRedirect(
        redirectLink,
        !features?.upgradeEnabled
          ? labels.deal_details.lbl_upgrade_this_deal
          : labels.deal_details.lbl_deal_to_cart
      );

      if (userLoggedIn && eligibleUpgradeList.length > 1) {

        updateJourneyStatus(null, upgradeStages.ELIGIBLE_NUMBER_SELECT);
      } else if (userLoggedIn && eligibleUpgradeList.length == 1) {

        updateJourneyStatus(
          eligibleUpgradeList[0].resultCode,
          upgradeStages.UPGRADE_RESULT
        );
        updateSelectedData(eligibleUpgradeList[0]);
      }
    } else {
      clickHandlerPrimary(false);
    }
  };

  const itemRemoved = (val) => {
    itemRemovedFromAddOns(val);
  };

  const navigateTo = (url, handoverSession = false) => {
    if (handoverSession) {
      handoverUpgradeeSession(canReciveOTP, isChildAllowed, upgradeResponse);
    }

    Router.push(url);
  };

  const updateSession = (label) => {

    TaggingHelper.tagSessionUpdate(dealDetails, label, productTaggingInfo);
    updateSessionStorage(labels.deal_details.lbl_session_storage, {
      value: selectedApplicationType?.title,
      id: dealDetails?.sku,
    });
  };

  const viewAffordableDeals = (url) => {
    if (url) {
      setLoadingState(true);
      router
        .push(
          `${urlPrefix}${url}?category=${dealCategoryId}&monthly_recurring=minValue:0,maxValue:${creditFilters?.total_monthly_payment}&isShowQualifying=true`
        )
        .then(() => {
          setLoadingState(false);
        });
    }
  };

  const viewCart = () => {
    setLoadingState(true);
    TaggingHelper.tagViewCart(analyticsData);

    router.push(`${urlPrefix}/cart`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  useEffect(() => {
    const buyOptionValue = getSessionStorage(
      labels.deal_details.lbl_session_storage
    );

    if (buyOptionValue && buyOptionValue.id === dealDetails?.sku) {
      deleteSessionStorage(labels.deal_details.lbl_session_storage);
    }

    setDevicePrice({
      devicePrice: dealDetails?.monthly_recurring,
      installment: dealDetails?.installment || 0,
      sku: dealDetails?.sku,
      analyticsOptions: {
        sales_product_id: [dealDetails?.sku],
        sales_product_quantity: [1],
        sales_product_category: [dealDetails?.categories?.[0]?.name],
        sales_product_price: [`${dealDetails?.monthly_recurring}`],
        sales_order_discount: dealDetails?.save_monthly_recurring,
      },
    });

    if (dealDetails?.promotion_tag_label == types.TYPE_PREORDER) {
      fetchPreOrderContent();
    }
  }, []);

  useEffect(() => {
    const selectedBuyOption = urlQuery?.buyOption && buyOptions
      ? buyOptions.find((option) => option?.sku == urlQuery?.buyOption)
      : null;
    const buyOption = urlQuery && selectedBuyOption
      ? selectedBuyOption
      : (Array.isArray(buyOptions) && buyOptions.length > 0)
        ? buyOptions[0]
        : {};

    setSelectedApplicationType(buyOption)
  }, [urlQuery, buyOptions]);

  useEffect(() => {
    if (addDeal) {
      handleAddDealToCart();
      addDealToCart(false);
    }
  }, [addDeal]);

  useEffect(() => {
    if (checkIsDealAffordable && creditFilters?.total_monthly_payment) {
      checkIfdealQualifies(false);
      getRecommendedDeals(
        unMaskedMsisdn,
        "",
        "",
        "",
        creditFilters?.total_monthly_payment,
        creditFilters?.deviceInstallment,
        creditFilters?.financeIndicator,
        dealDetails?.sku
      ).then((result) => {
        // 200 or 204 check isUpgradeAffordable("Y" | "N")
        if (result.fail) {
          displayHideUpgradeModal(true);
          updateJourneyStatus(
            errorCodes.service_down,
            upgradeStages.TECHNICAL_ERROR
          );

          return;
        }

        if (result?.response?.data?.isUpgradeAffordable === "N") {
          setShowAffordModal(true);
        } else {
          handleAddDealToCart();
        }
      });
    }
  }, [checkIsDealAffordable, creditFilters]);

  useEffect(() => {
    setShowAddons(!!vasList.length)
  }, [vasList]);

  useEffect(() => {
    if (showSnackBar) {
      const SnackbarShowDuration = 3000;
      let timer = setTimeout(() => handleSnackBarClose(), SnackbarShowDuration);

      return () => clearTimeout(timer);
    }
  }, [showSnackBar]);

  useEffect(() => {
    if (isMobile) {
      setTimeout(() => {
        setRenderModal(true);
      }, 1000);
    }

  }, [isDealInCart]);

  const modalDisplayData = {
    iconUrl: `${imagePrefix}/assets/images/icon-info.svg`,
    title: labels.upgrade.lbl_still_upgrading,
    description: labels.upgrade.lbl_processing_desc,
    primaryButtonText: labels.upgrade.lbl_continue_upgrade,
    onClickHandlerPrimary: () => clickHandlerPrimary(true),
    secondaryButtonText: labels.upgrade.lbl_apply_new_contract,
    secondaryButtonStyle: "flat black",
    onClickHandlerSecondary: clickHandlerSecondary,
  };
  const isUpgrade = selectedApplicationType?.title && selectedApplicationType?.title === buyOptions[1]?.title;

  return (
    <>
      {showSnackBar && !isMobile && (
        <SnackBar
          message={labels.deal_details.lbl_deal_added}
          className={styles.snackBarSpacing}
          labelStyling={`${styles["msg-label"]}`}
          closeSnackBar={handleSnackBarClose}
          isVisible={showSnackBar}
          id={`${dealDetails?.sku}-popup`}
        />
      )}

      {showAffordModal && (
        <AffordabilityContainer
          showModal={showAffordModal}
          resultCode={labels.upgrade.errorCodes.code_deal_not_affordable}
          toggleModal={() => setShowAffordModal(false)}
        />
      )}

      {showAlertModal && isShowAffordDeal && alertModalContent && (
        <UnaffordableAlertModal
          showModal={showAlertModal}
          displayData={alertModalContent}
          onClickHandlerPrimary={viewAffordableDeals}
          toggleModal={closeUnaffordableAlertModal}
        />
      )}

      {showUpgradeConfirmModal && (
        <UpgradeComponent
          showModal={showUpgradeConfirmModal}
          displayData={modalDisplayData}
          toggleModal={handleModalDismiss}
        />
      )}

      {isDealInCart && isMobile && (
        <AddedToCartPopup
          dealSKU={dealDetails?.sku}
          onContinueShopping={handleContinueShopping}
          imageUrl={'/assets/images/success-circle-o-copy.svg'}
          onCloseModal={closeOptions}
          showModal={renderModal}
          viewCart={viewCart}
        />
      )}

      <Row>
        <SummeryWizard>
          <WizardSection sectionTitle="Confirm your application type" >
            <ApplicationTypeSelector
              buyOptions={buyOptions}
              buyOptionSelected={selectedApplicationType}
              handleSelectedBuyOption={handleSelectedBuyOption}
            />

          </WizardSection>

          <WizardSection sectionTitle="Review your selected deal" >
            <DealHighlights isDealDetailPage={isDealDetailPage} />
          </WizardSection>

          <WizardSection sectionTitle="Choose the duration & price:" showAsSubsection>
            { lowCompLaod
              ? <div className={`${styles["loading_placeholder"]}`} ><div className={`${styles["animated-background"]}`} ></div></div>
              :<>
                <DealDurationAndPrice handleContract={handleContract} />

                <DealDetailsIndicators
                  deliveryAndReturn={dealDetails?.delivery_and_return}
                  isUpgradeSelection={features?.upgradeChecksEnabled
                    && selectedApplicationType?.title === buyOptions?.[1]?.title
                  }
                  isUpgradeEnabled={features?.upgradeEnabled}
                  onUpgradeAction={handleFindOut}
                  stockMessages={dealDetails?.stock_message}
                />
            </>}

          </WizardSection>

          <WizardSection sectionTitle="Choose your add-ons" isOptional isSectionHidden={!isShowVas}>
            <AddOns
              isShowVas={isShowVas}
              isVasAvailableWithCurrentDeal={isVasAvailableWithCurrentDeal}
              isVasRemoved={isVasRemoved}
              contractCoverTitle={contractCoverTitle}
              contractCoverDescription={contractCoverDescription}
            />
          </WizardSection>

          <WizardSection sectionTitle={
            !isUpgrade
              ? "Review contract & add to your cart"
              : "Review your contract"
          }>

            {showAddons && (
              <VASAddons
                currentDealSku={dealDetails?.sku}
                totalPrice={Math.round(dealDetails?.monthly_recurring)}
                paymentTerms={
                  " PM x " +
                  Math.round(dealDetails?.payment_terms_label?.split(" ")[0])
                }
                itemRemoved={itemRemoved}
              />
            )}

            {lowCompLaod
              ? <div className={`${styles["loading_placeholder"]}`} ><div className={`${styles["animated-background"]}`} ></div></div>
              : <DealDetailSummary />}

            <DealSpecificationControl
              addDealToCartEnabled={addDealToCartEnabled}
              buyOptions={buyOptions}
              ctaText={ctaText}
              handleAddToCart={handleAddToCart}
              handleUpgrade={handleUpgrade}
              isBackOrderDealUnavailable={isBackOrderDealUnavailable}
              viewCart={viewCart}
            />

            {showPreOrderInfo
              && dealDetails?.promotion_tag_label == types.TYPE_PREORDER
              && selectedApplicationType?.title
              && buyOptions
              && selectedApplicationType?.title === buyOptions[0].title
              && (
                <CustomContainer
                  className={`${styles["pre-order-deal-message"]}`}
                >
                  <Image
                    className="mr-2"
                    img_path={`${imagePrefix}/assets/images/toolTip-icon.svg`}
                    img_width="1.125rem"
                    img_height="1.125rem"
                  />
                  <CustomContainer>{preOrderMessage}</CustomContainer>
                </CustomContainer>
              )
            }

          </WizardSection>
        </SummeryWizard>
      </Row>

      <CustomContainer className={`${styles["product-indicator-container"]}`} />
    </>
  );
};

DealDetailsBody.propTypes = {
  backOderDealUnavailable: PropTypes.func,
  dealCategoryId: PropTypes.string,
  geoLocationIsAllowed: PropTypes.bool,
  handleContract: PropTypes.func,
  isCandCEligible: PropTypes.bool,
  isDealDetailPage: PropTypes.bool,
  isStoreStockServiceDown: PropTypes.bool,
  isVasloaded: PropTypes.func,
  nearestStore: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  onShowModalStores: PropTypes.func,
  urlQuery: PropTypes.object,

  //redux
  addDealToCart: PropTypes.func,
  addBundleProductToGuestCart: PropTypes.func,
  addDeal: PropTypes.bool,
  canReciveOTP: PropTypes.bool,
  checkIfdealQualifies: PropTypes.func,
  checkIsDealAffordable: PropTypes.bool,
  clearUpgradeJourney: PropTypes.func,
  creditFilters: PropTypes.object,
  dealDetails: PropTypes.object,
  displayHideUpgradeModal: PropTypes.func,
  eligibleUpgradeList: PropTypes.arrayOf(PropTypes.object),
  features: PropTypes.object,
  fetchCreditFilters: PropTypes.func,
  getRecommendedDeals: PropTypes.func,
  isChildAllowed: PropTypes.bool,
  isMiniApp: PropTypes.bool,
  isShowAffordDeal: PropTypes.bool,
  selectedApplicationType: PropTypes.object,
  setDevicePrice: PropTypes.func,
  setSelectedApplicationType: PropTypes.func,
  showUpgradeModal: PropTypes.bool,
  unMaskedMsisdn: PropTypes.string,
  updateJourneyStatus: PropTypes.func,
  updateSelectedData: PropTypes.func,
  updateUpgradeRedirect: PropTypes.func,
  upgradeCheckDone: PropTypes.bool,
  upgradeResponse: PropTypes.object,
  userLoggedIn: PropTypes.bool,
  lowCompLaod: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  addDeal: state.upgrade.addDeal,
  canReciveOTP: state.upgrade.canReciveOTP,
  checkIsDealAffordable: state.upgrade.checkIsDealAffordable,
  creditFilters: state.upgrade.creditFilters,
  dealDetails: state.dealDetails.selectedDealDetails,
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  features: state.common.features,
  isChildAllowed: state.upgrade.isChildAllowed,
  isMiniApp: state.navDetails.isMiniApp,
  isShowAffordDeal: state.creditCheckDetails.isShowAffordDeal,
  selectedApplicationType: state.dealDetails.selectedApplicationType,
  showUpgradeModal: state.upgrade.showModal,
  unMaskedMsisdn: state.upgrade.unMaskedMsisdn,
  upgradeCheckDone: state.upgrade.upgradeCheckDone,
  upgradeResponse: state.upgrade.upgradeResponse,
  userLoggedIn: state.navDetails.isUserLoggedIn,
});

const mapDispatchToProps = {
  addBundleProductToGuestCart,
  addDealToCart,
  checkIfdealQualifies,
  clearUpgradeJourney,
  displayHideUpgradeModal,
  fetchCreditFilters,
  getRecommendedDeals,
  setDevicePrice,
  updateJourneyStatus,
  updateSelectedData,
  updateUpgradeRedirect,
  setSelectedApplicationType: DealActionSetSelectedApplicationType
};

export default connect(mapStateToProps, mapDispatchToProps)(DealDetailsBody);
